import { render, staticRenderFns } from "./ProfilBilgilerim.vue?vue&type=template&id=286c7f85&"
import script from "./ProfilBilgilerim.vue?vue&type=script&lang=js&"
export * from "./ProfilBilgilerim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports